import React from "react";
import bg from "../../assets/image/tempbg.png";
import img from "../../assets/icons/verifiedicon.png";
import { baseUrl } from "../../utils/base_url";
import { useMediaQuery } from "react-responsive";
import {
  _1200px,
  _1400px,
  _1500px,
  _1600px,
  _1700px,
  _1800px,
  _576px,
  _768px,
  _992px,
  _450px,
} from "../../utils/mediaBreakpoints";
import line from "../../assets/image/line2.png";
import career3bg from "../../assets/image/career3bg.png";
import careericon1 from "../../assets/image/careericon1.png";
import careericon2 from "../../assets/image/careericon2.png";
import careericon3 from "../../assets/image/careericon3.png";
const sources = [
  { heading: "Autonomy", image: `${careericon1}` },
  { heading: "Diversity", image: `${careericon2}` },
  { heading: "Recognition", image: `${careericon3}` },
];
const TrustWorthyAI = ({ isMobile, data }) => {
  const _450 = useMediaQuery({ maxWidth: _450px });
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1500 = useMediaQuery({ maxWidth: _1500px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  return (
    <>
      <div className="row p-0" style={{ backgroundColor: "rgb(1, 25, 159)" }}>
        <div className="d-flex flex-column gap-4 p-0 position-relative  ">
          <img
            // className="vh-75"
            src={`${
              data?.background_image?.url
                ? `${baseUrl}${data?.background_image?.url}`
                : `${career3bg}`
            }`}
            alt=""
            style={{
              opacity: "10%",
              objectFit: "cover",
              height: _576
                ? "85vh"
                : _768
                ? "55vh"
                : _992
                ? "80vh"
                : _1200
                ? "85vh"
                : _1400
                ? "90vh"
                : _1500
                ? "95vh"
                : _1600
                ? "100vh"
                : _1700
                ? "100vh"
                : _1800
                ? "100vh"
                : "100vh",
            }}
          />
          <div
            className="d-flex flex-column align-items-center w-100 position-absolute vh-100"
            style={{
              padding: _576
                ? "2rem 0rem 0rem 0rem"
                : _768
                ? "4rem 0rem 0rem 0rem"
                : _992
                ? "7rem 0rem 0rem 0rem"
                : "8rem 0rem 0rem 0rem",
            }}
          >
            <div className="d-flex flex-column gap-4 align-items-center text-center  ">
              {data?.heading &&
                (() => {
                  const phrase = "Built for Accuracy";
                  return (
                    <p
                      className={`text-white fw900`}
                      style={{
                        fontSize: _450
                          ? "22px"
                          : _576
                          ? "25px"
                          : _768
                          ? "25px"
                          : _992
                          ? "30px"
                          : _1200
                          ? "35px"
                          : _1400
                          ? "45px"
                          : _1600
                          ? "55px"
                          : _1700
                          ? "60px"
                          : _1800
                          ? "70px"
                          : "70px",
                        lineHeight: _450
                          ? "25px"
                          : _576
                          ? "30px"
                          : _768
                          ? "34px"
                          : _992
                          ? "38px"
                          : _1200
                          ? "48px"
                          : _1400
                          ? "54px"
                          : _1600
                          ? "60px"
                          : _1700
                          ? "66px"
                          : _1800
                          ? "70px"
                          : "70px",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: _576
                          ? data?.heading?.replace(
                              phrase,
                              `<span style="color: #459EFF">${phrase}</span>`
                            )
                          : data?.heading
                              ?.split("\n")
                              ?.join("<br/>")
                              ?.replace(
                                phrase,
                                `<span style="color: #459EFF">${phrase}</span>`
                              ),
                      }}
                    />
                  );
                })()}
              {!data?.heading && (
                <p
                  className={`text-white fw900`}
                  style={{
                    fontSize: _450
                      ? "22px"
                      : _576
                      ? "25px"
                      : _768
                      ? "30px"
                      : _992
                      ? "30px"
                      : _1200
                      ? "40px"
                      : _1400
                      ? "45px"
                      : _1600
                      ? "55px"
                      : _1700
                      ? "60px"
                      : _1800
                      ? "70px"
                      : "70px",
                    lineHeight: _450
                      ? "25px"
                      : _576
                      ? "30px"
                      : _768
                      ? "34px"
                      : _992
                      ? "38px"
                      : _1200
                      ? "48px"
                      : _1400
                      ? "54px"
                      : _1600
                      ? "60px"
                      : _1700
                      ? "66px"
                      : _1800
                      ? "70px"
                      : "70px",
                  }}
                  // dangerouslySetInnerHTML={{
                  //   __html: data?.heading
                  //     ?.split("\n")
                  //     ?.join("<br/>")
                  //     ?.replace(
                  //       phrase,
                  //       `<span style="color: #459EFF">${phrase}</span>`
                  //     ),
                  // }}
                >
                  Why work with Ask Fides?
                </p>
              )}

              {data?.sub_heading ? (
                <p
                  dangerouslySetInnerHTML={{
                    __html: _576
                      ? data?.sub_heading
                      : data?.sub_heading?.split("\n")?.join("<br/>"),
                  }}
                  style={{
                    lineHeight: _450
                      ? "12px"
                      : _576
                      ? "16px"
                      : _768
                      ? "16px"
                      : _992
                      ? "18px"
                      : _1200
                      ? "20px"
                      : _1400
                      ? "24px"
                      : _1600
                      ? "28px"
                      : _1700
                      ? "34px"
                      : _1800
                      ? "40px"
                      : "40px",
                    fontSize: _450
                      ? "13px"
                      : _576
                      ? "15px"
                      : _768
                      ? "15px"
                      : _992
                      ? "15px"
                      : _1200
                      ? "15px"
                      : _1400
                      ? "17px"
                      : _1600
                      ? "19px"
                      : _1700
                      ? "22px"
                      : _1800
                      ? "26px"
                      : "26px",
                  }}
                  className="fw700 text-white px-4"
                />
              ) : (
                <p
                  // dangerouslySetInnerHTML={{
                  //   __html: data?.sub_heading?.split("\n")?.join("<br/>"),
                  // }}
                  style={{
                    lineHeight: _450
                      ? "15px"
                      : _576
                      ? "16px"
                      : _768
                      ? "16px"
                      : _992
                      ? "18px"
                      : _1200
                      ? "20px"
                      : _1400
                      ? "24px"
                      : _1600
                      ? "28px"
                      : _1700
                      ? "34px"
                      : _1800
                      ? "40px"
                      : "40px",
                    fontSize: _450
                      ? "14px"
                      : _576
                      ? "14px"
                      : _768
                      ? "15px"
                      : _992
                      ? "15px"
                      : _1200
                      ? "15px"
                      : _1400
                      ? "17px"
                      : _1600
                      ? "19px"
                      : _1700
                      ? "22px"
                      : _1800
                      ? "26px"
                      : "26px",
                  }}
                  className="fw700 text-white px-4"
                >
                  We are in equal opportunity employer cherishing professionals
                  and
                  {_576 ? "" : <br />} young career practitioners from all over
                  the globe
                  {_576 ? "" : <br />} with varying talents.
                </p>
              )}
            </div>
            <div
              style={{
                padding: _576
                  ? "1rem 0rem 0rem 0rem"
                  : _768
                  ? "4rem 0rem 0rem 0rem"
                  : "7rem 0rem 0rem 0rem",
              }}
              className="w-100"
            >
              <AccuracyComp
                data={data?.trustAndSources ? data?.trustAndSources : sources}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export const AccuracyComp = ({ data }) => {
  const _450 = useMediaQuery({ maxWidth: _450px });
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });

  return (
    <>
      <div className="container-fluid contwidth">
        <div className="col-12 p-0 m-0 ">
          <div className="row p-0 m-0">
            {data?.map((obj, idx) => (
              <div key={idx} className="col-12 pb-4 pb-sm-0 col-sm-4 p-0 ">
                <div className="  d-flex justify-content-between align-items-center">
                  {idx !== 0 ? (
                    <img
                      src={line}
                      className="d-none d-md-block"
                      alt=""
                      height={
                        _450
                          ? 40
                          : _576
                          ? 60
                          : _768
                          ? 80
                          : _992
                          ? 90
                          : _1200
                          ? 110
                          : _1400
                          ? 120
                          : _1600
                          ? 140
                          : _1700
                          ? 160
                          : _1800
                          ? 190
                          : 190
                      }
                    />
                  ) : (
                    " "
                  )}
                  <AccuracyCard data={obj} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export const AccuracyCard = ({ data }) => {
  const _450 = useMediaQuery({ maxWidth: _450px });
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  return (
    <>
      <div className="d-flex  w-100 flex-column gap-3 align-items-center justify-content-center">
        <img
          src={`${
            data?.image?.url ? `${baseUrl}${data?.image?.url}` : data?.image
          }`}
          alt=""
          width={
            _450
              ? 60
              : _576
              ? 60
              : _768
              ? 60
              : _992
              ? 90
              : _1200
              ? 100
              : _1400
              ? 100
              : _1600
              ? 120
              : _1700
              ? 120
              : _1800
              ? 140
              : 140
          }
        />
        <p
          className="text-white fw700 text-center lh-1"
          style={{
            fontSize: _450
              ? "15px"
              : _576
              ? "15px"
              : _768
              ? "14px"
              : _992
              ? "16px"
              : _1200
              ? "16px"
              : _1400
              ? "18px"
              : _1600
              ? "20px"
              : _1700
              ? "25px"
              : _1800
              ? "30px"
              : "30px",
            // lineHeight: _450
            //   ? "8px"
            //   : _576
            //   ? "10px"
            //   : _768
            //   ? "16px"
            //   : _992
            //   ? "18px"
            //   : _1200
            //   ? "20px"
            //   : _1400
            //   ? "24px"
            //   : _1600
            //   ? "28px"
            //   : _1700
            //   ? "34px"
            //   : _1800
            //   ? "40px"
            //   : "40px",
          }}
          dangerouslySetInnerHTML={{
            __html: data?.heading?.split("\n")?.join("<br/>"),
          }}
        />
      </div>
    </>
  );
};

export default TrustWorthyAI;
